export const optionsBlockTypes = [
  { value: "", label: "Seleziona tipo di blocco" },
  { value: "Text", label: "Testo" },
  { value: "Quote", label: "Citazione" },
  { value: "TextImage", label: "Testo e Immagine" },
  { value: "TextCarousel", label: "Testo e Carosello immagini" },
  { value: "Image", label: "Immagine" },
  { value: "TwoImages", label: "Due immagini (Confronto)" },
  { value: "ImageCarousel", label: "Carosello immagini" },
  { value: "ImageGrid", label: "Griglia immagini" },
  { value: "ImageGridText", label: "Griglia immagini + testo" },
]

export const mediaFitOptions = [
  { value: "fit", label: "Fit" },
  { value: "cover", label: "Cover" },
]

export const mediaWidthOptions = [
  { value: "100%", label: "100%" },
  { value: "50%", label: "50%" },
  { value: "auto", label: "Auto" },
]

export const captionModeOptions = [
  { value: "single", label: "Didascalia unica" },
  { value: "perItem", label: "Didascalia per immagine" },
]

export const textPositionOptions = [
  { value: "left", label: "Sinistra" },
  { value: "right", label: "Destra" },
]

export const gridRowsOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
]

export const gridColsOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
]

export const bgColorOptions = [
  { value: "#E9DDC4", label: "Beige" },
  { value: "#000000", label: "Nero" },
  { value: "#FFFFFF", label: "Bianco" },
  { value: "#E11729", label: "Rosso" },
]

export const mediaPositionOptions = [
  { label: "Centro", value: "center center" },
  { label: "Alto", value: "center top" },
  { label: "Basso", value: "center bottom" },
  { label: "Sinistra", value: "left center" },
  { label: "Destra", value: "right center" },
  { label: "Alto sinistra", value: "left top" },
  { label: "Alto destra", value: "right top" },
  { label: "Basso sinistra", value: "left bottom" },
  { label: "Basso destra", value: "right bottom" },
]